import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadDefaultFolderTemplate, leadDefaultFolderTemplatesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const LEAD_DEFAULT_FOLDER_TEMPLATE_MODULE = 'leaddefaultfoldertemplates';

const dataObjectModule = getDataObjectsModule<ILeadDefaultFolderTemplate>(leadDefaultFolderTemplatesManager, 3);
const searchModule = getSearchModule<ILeadDefaultFolderTemplate>(leadDefaultFolderTemplatesManager);

const leadDefaultFolderTemplateModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(LEAD_DEFAULT_FOLDER_TEMPLATE_MODULE, leadDefaultFolderTemplateModuleInstance);

export { LEAD_DEFAULT_FOLDER_TEMPLATE_MODULE };
